import { ObjectMapper } from 'json-object-mapper';

export enum StandardFieldValidationBehavior {
  Disabled = 0,
  Block = 1,
  Alert = 2,
}

export class StandardFieldValidationBehaviorEnum {
  static readonly Disabled = { value: StandardFieldValidationBehavior.Disabled, label: 'Desabilitado' };
  static readonly Block = { value: StandardFieldValidationBehavior.Block, label: 'Bloqueio' };
  static readonly Alert = { value: StandardFieldValidationBehavior.Alert, label: 'Alerta' };

  static buildListEnum() {
    return [this.Disabled, this.Block, this.Alert];
  }

  static buildBehaviorOptions() {
    return this.buildListEnum().filter(
      option => option.value !== StandardFieldValidationBehavior.Disabled
    );
  }

  static normalizeBehavior(
    value: unknown,
    fallback: StandardFieldValidationBehavior = StandardFieldValidationBehavior.Block
  ): StandardFieldValidationBehavior {
    if (value === null || value === undefined || value === '') {
      return fallback;
    }

    if (typeof value === 'number' && !Number.isNaN(value)) {
      return value as StandardFieldValidationBehavior;
    }

    if (typeof value === 'string') {
      const numeric = Number(value);
      if (!Number.isNaN(numeric)) {
        return numeric as StandardFieldValidationBehavior;
      }

      const byKey = StandardFieldValidationBehavior[value as keyof typeof StandardFieldValidationBehavior];
      if (typeof byKey === 'number') {
        return byKey;
      }
    }

    return fallback;
  }
}

export class StandardFieldValidationCatalogModel {
  validationKey: string = '';
  movementType: number = 0;
  fieldKey: string = '';
  name: string = '';
  description: string = '';
  defaultBehavior: StandardFieldValidationBehavior = StandardFieldValidationBehavior.Block;
  defaultAlertMessage: string = '';
  order: number = 0;

  static create(input: Partial<StandardFieldValidationCatalogModel> = {}) {
    const normalized = { ...(input || {}) };
    if ('defaultBehavior' in normalized) {
      normalized.defaultBehavior = StandardFieldValidationBehaviorEnum.normalizeBehavior(
        normalized.defaultBehavior,
        StandardFieldValidationBehavior.Block
      );
    }

    return ObjectMapper.deserialize<StandardFieldValidationCatalogModel>(
      StandardFieldValidationCatalogModel,
      normalized
    );
  }
}

export class StandardFieldValidationResolvedModel extends StandardFieldValidationCatalogModel {
  enabled: boolean = true;
  behavior: StandardFieldValidationBehavior = StandardFieldValidationBehavior.Block;
  alertMessage: string = '';
  approvalScopeItemId: string = '';

  static create(input: Partial<StandardFieldValidationResolvedModel> = {}) {
    const normalized = { ...(input || {}) };
    if ('behavior' in normalized) {
      normalized.behavior = StandardFieldValidationBehaviorEnum.normalizeBehavior(normalized.behavior);
    }
    if ('defaultBehavior' in normalized) {
      normalized.defaultBehavior = StandardFieldValidationBehaviorEnum.normalizeBehavior(
        normalized.defaultBehavior,
        StandardFieldValidationBehavior.Block
      );
    }

    return ObjectMapper.deserialize<StandardFieldValidationResolvedModel>(
      StandardFieldValidationResolvedModel,
      normalized
    );
  }
}

export class ApprovalScopeStandardFieldValidationConfigModel {
  validationKey: string = '';
  enabled: boolean = true;
  behavior: StandardFieldValidationBehavior = StandardFieldValidationBehavior.Block;
  alertMessage: string = '';

  static create(input: Partial<ApprovalScopeStandardFieldValidationConfigModel> = {}) {
    return ObjectMapper.deserialize<ApprovalScopeStandardFieldValidationConfigModel>(
      ApprovalScopeStandardFieldValidationConfigModel,
      input || {}
    );
  }
}

export class StandardFieldValidationMessageModel {
  validationKey: string = '';
  message: string = '';

  static create(input: Partial<StandardFieldValidationMessageModel> = {}) {
    return ObjectMapper.deserialize<StandardFieldValidationMessageModel>(
      StandardFieldValidationMessageModel,
      input || {}
    );
  }
}
